import React, { useState } from "react";
import { RxCross1 } from "react-icons/rx";
import "./UserAddress.css"
import {useDispatch , useSelector} from "react-redux"
import { createAddressAction } from "../../../redux/actions/User";
import toast from "react-hot-toast";

const CreateAddressModal = ({ setHideModal }) => {
  const loading = useSelector((state) => state.user.isLoading);
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [fromData , setFormData] = useState({
    streetAddress  :"",
    country : "",
    city  :"",
    state  :"",
    postalCode  :"",
    name : ""
  });


  const handleChange = (e)=>{
    setFormData({
      ...fromData,
      [e.target.name] : e.target.value
    })
  }


  const handleSubmit = async ()=>{
    if(!fromData.city || !fromData.country || !fromData.postalCode|| !fromData.state|| !fromData.streetAddress){
      return toast.error("Enter all fields")
    }

    const newFormData = {
      Address1: fromData.streetAddress,
      Address2: "",
      City: fromData.city,
      State: fromData.state,
      ZipCode: fromData.postalCode,
      Country: fromData.country,
      FullName:
        fromData.name ||
        `${user?.firstName || ""} ${user?.lastName || ""}`.trim() ||
        "Billing Address",
      phoneNumber: user?.phoneNumber || "",
      email: user?.email || "",
    };
    dispatch(createAddressAction(newFormData, setHideModal));
  }





  return (
    <div className="fixed left-0 top-[-17px] flex pb-[20px]  min-h-[103vh] max-h-[120vh] w-full items-center justify-center bg-black bg-opacity-[.9] !z-[1300000000000000000] py-10">
      <div className="address max-h-full relative w-full max-w-xl h-auto sm:rounded-2xl bg-black shadow-redColor !text-color2"
      
      >
        <RxCross1
          className="absolute top-3 right-3 text-[23px] cursor-pointer"
          onClick={() => {
            setHideModal(false);
          }}
        />
        <div className="w-full py-3 px-3 h-auto">
          <h2 className="text-center text-[25px] font-bold mb-2">
            Create new address
          </h2>
          {/* ------  */}
          <div className="my-2">
            <div className="my-2">
              <label htmlFor="" className="w-[100%] block mb-1 px-2">
                Address Name
              </label>
              <input
                type="text"
                value={fromData.name}
                name="name"
                onChange={handleChange}
                placeholder="Enter Address Name"
                className="w-[100%] border-[1px] border-color3 bg-color1 outline-none px-3 py-2 !text-color2 rounded-md"
              />
            </div>
            <div className="my-2">
              <label htmlFor="" className="w-[100%] block mb-1 px-2">
                Complete Address
              </label>
              <input
                type="text"
                value={fromData.streetAddress}
                name="streetAddress"
                onChange={handleChange}
                placeholder="Enter Address Name"
                className="w-[100%] border-[1px] border-color3 bg-color1 outline-none px-3 py-2 !text-color2 rounded-md"
              />
            </div>
            {/* <div className="flex justify-start place-items-center gap-2 input_div">
              <div className="my-2 w-[100%]">
                <label htmlFor="" className="w-[100%] block mb-1 px-2">
                  First Name
                </label>
                <input
                  type="text"
                  placeholder="First Name"
                  className="w-[100%] border-[1px] border-color3 bg-color1 outline-none px-3 py-2 !text-color2 rounded-md"
                />
              </div>
              <div className="my-2 w-[100%]">
                <label htmlFor="" className="w-[100%] block mb-1 px-2">
                  Last Name
                </label>
                <input
                  type="text"
                  placeholder="Last Name"
                  className="w-[100%] border-[1px] border-color3 bg-color1 outline-none px-3 py-2 !text-color2 rounded-md"
                />
              </div>
            </div> */}
            <div className="flex justify-start place-items-center gap-2 input_div">
              <div className="my-2 w-[100%]">
                <label htmlFor="" className="w-[100%] block mb-1 px-2">
                  Country
                </label>
                <input
                  type="text"
                  value={fromData.country}
                  name="country"
                  onChange={handleChange}
                  placeholder="Enter Your Country Name"
                  className="w-[100%] border-[1px] border-color3 bg-color1 outline-none px-3 py-2 !text-color2 rounded-md"
                />
              </div>
              <div className="my-2 w-[100%]">
                <label htmlFor="" className="w-[100%] block mb-1 px-2">
                  City
                </label>
                <input
                  type="text"
                  value={fromData.city}
                  name="city"
                  onChange={handleChange}
                  placeholder="Enter Your City Name"
                  className="w-[100%] border-[1px] border-color3 bg-color1 outline-none px-3 py-2 !text-color2 rounded-md"
                />
              </div>
            </div>
            <div className="my-2">
              <label htmlFor="" className="w-[100%] block mb-1 px-2">
                State
              </label>
              <input
                type="text"
                value={fromData.state}
                name="state"
                onChange={handleChange}
                placeholder="Enter Your State Name"
                className="w-[100%] border-[1px] border-color3 bg-color1 outline-none px-3 py-2 !text-color2 rounded-md"
              />
            </div>
            <div className="my-2">
              <label htmlFor="" className="w-[100%] block mb-1 px-2">
                Postal Code
              </label>
              <input
                type="text"
                value={fromData.postalCode}
                name="postalCode"
                onChange={handleChange}
                placeholder="Enter Your PostalCode"
                className="w-[100%] border-[1px] border-color3 bg-color1 outline-none px-3 py-2 !text-color2 rounded-md"
              />
            </div>
            
  
            <button onClick={handleSubmit} disabled={loading} className={`bg-white text-black hover:bg-color2 hover:text-color1 hover:border-[1px] py-2 border-[1px] border-[black] px-3 cursor-pointer w-full mt-2 rounded-md disabled:cursor-not-allowed`}>
             {
              loading ? "Creating..."  :"Create Address"
             }
              
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateAddressModal;
